exports = module.exports = require("../../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, "\n#tableDivId[data-v-949eeb9c]{\n  min-height: 0px;\n}\n", ""]);

// exports
